<h2 mat-dialog-title>
  @if (dialogIcon) {
    <mat-icon>{{ dialogIcon }}</mat-icon>
  }
  {{ dialogTitle }}
</h2>

<mat-dialog-content>
  @if (!isHtmlMessage) {
    <div>
      {{ dialogData.dialogContent }}
    </div>
  }

  @if (isHtmlMessage) {
    <div [innerHTML]="dialogData.dialogContent"></div>
  }
</mat-dialog-content>

<mat-dialog-actions
  class="dialog-actions"
  [ngClass]="{ single: dialogData.dialogButton === DialogButton.ok }"
>
  @if (dialogData.dialogButton !== DialogButton.ok) {
    <button mat-stroked-button (click)="close()">
      {{ getButtonText(false) }}
    </button>
  }

  <button mat-flat-button color="primary" (click)="submit()">
    {{ getButtonText(true) }}
  </button>
</mat-dialog-actions>
